import type { LyricsLine } from '@/types/reader'

const LRC_TIME_RE = /\[(\d{1,2}):(\d{2})(?:[.:](\d{1,3}))?\]/g

function parseTimestamp(minutes: string, seconds: string, fraction?: string) {
  const wholeSeconds = Number(minutes) * 60 + Number(seconds)
  if (!fraction) return wholeSeconds

  const padded = fraction.padEnd(3, '0').slice(0, 3)
  return wholeSeconds + Number(padded) / 1000
}

export function parseLrc(lrc: string): LyricsLine[] {
  const lines: LyricsLine[] = []

  for (const rawLine of lrc
    .replace(/\r\n/g, '\n')
    .replace(/\r/g, '\n')
    .split('\n')) {
    LRC_TIME_RE.lastIndex = 0
    const matches = [...rawLine.matchAll(LRC_TIME_RE)]
    if (matches.length === 0) continue

    LRC_TIME_RE.lastIndex = 0
    const text = rawLine.replace(LRC_TIME_RE, '').trim()
    for (const match of matches) {
      const [, minutes, seconds, fraction] = match
      lines.push({
        startTime: parseTimestamp(minutes, seconds, fraction),
        text
      })
    }
  }

  const sorted = lines.sort((a, b) => a.startTime - b.startTime)

  return sorted.map((line, index) => ({
    ...line,
    endTime: line.endTime ?? sorted[index + 1]?.startTime
  }))
}

export function hasLrcTimestamps(text: string) {
  LRC_TIME_RE.lastIndex = 0
  const hasTimestamps = LRC_TIME_RE.test(text)
  LRC_TIME_RE.lastIndex = 0
  return hasTimestamps
}
